import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/ar/poi-button-data/poi-button-data.js';
      import {ObcPoiObjectDataStyle, ObcPoiObjectDataState} from '@oicl/openbridge-webcomponents/dist/ar/poi-object-data/poi-object-data.js';
import {ObcPoiButtonLayout, ObcPoiButtonState, PoiButtonVisualState, ObcPoiButtonType, ObcPoiButtonDataItem} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-button/poi-button.js';

      export interface Props {
     dataStyle?: ObcPoiObjectDataStyle;
     dataState?: ObcPoiObjectDataState | null;
     dataInteractive?: boolean;
     relativeDirection?: number;
     selected?: boolean;
     layout?: ObcPoiButtonLayout;
     hasHeader?: boolean;
     state?: ObcPoiButtonState;
     value?: PoiButtonVisualState;
     overlapOpaque?: boolean;
     type?: ObcPoiButtonType;
     inExpandedGroup?: boolean;
     data?: ObcPoiButtonDataItem[];
     hasRelation?: boolean;
     headerContent?: string
   }

      
  
      export type {ObcPoiObjectDataStyle, ObcPoiObjectDataState} from '@oicl/openbridge-webcomponents/dist/ar/poi-object-data/poi-object-data.js';
export type {ObcPoiButtonLayout, ObcPoiButtonState, PoiButtonVisualState, ObcPoiButtonType, ObcPoiButtonDataItem} from '@oicl/openbridge-webcomponents/dist/ar/building-blocks/poi-button/poi-button.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcPoiButtonData',
  props: {
    dataStyle: {},
    dataState: {},
    dataInteractive: { type: Boolean },
    relativeDirection: {},
    selected: { type: Boolean },
    layout: {},
    hasHeader: { type: Boolean },
    state: {},
    value: {},
    overlapOpaque: { type: Boolean },
    type: {},
    inExpandedGroup: { type: Boolean },
    data: {},
    hasRelation: { type: Boolean },
    headerContent: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-poi-button-data',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})